import * as React from "react";
import Component from "../../AbstractComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import Charge2State from "../../Partials/Charge/Charge2State";

export default class Charge2Summary extends Component {
  public state = {

  };

  constructor(public props) {
    super(props);
  }

  public render() {
    const charge: ChargeInterface = this.props.charge;

    return (
      <div className="charge-summary">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div className="title">
            {charge?.isReceivable ? this.trans("charge-summary-title/receivable") : this.trans("charge-summary-title/payable")}
          </div>
          <div className="date">
            {charge &&
              charge.financialStatement &&
              // charge.financialStatement.locked
              // ? this.formatter.formatDate(charge.financialStatement.updatedAt)
              // : this.formatter.formatDate(charge?.orderDate)}
              this.formatter.formatDate(charge?.createdAt)}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
          <div className="counterparty">
            {/* {`${charge?.name || ""} ${charge?.hasSavingsType ? `(${this.trans("charge/payment-summary-title/savings")})` : ""}`} */}
            {`${(charge?.type?.id === 255 || charge?.type?.id === 254 ? charge?.linkedPayments[0]?.name : charge?.name) || ""} ${charge?.hasSavingsType ? `(${this.trans("charge/payment-summary-title/savings")})` : ""}`}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div className="currency">
              {charge?.currency?.getIso()}
            </div>
            <div className="amount">
              {!this.props.newCardStyles ? this.formatter.formatNumber(charge?.amount) : this.formatter.formatNumber(charge?.amountPaidFromPayments(charge?.paymentIds))}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <table>
            <tr>
              <td className="align-left first-column">
                {`${this.trans("object")}:`}
              </td>
              <td className="align-left">
                <div
                  className="link-to-entity"
                  onClick={() => this.redirect(`/app/${charge?.relatedEntity.nameForUrl}/update/${charge?.relatedEntity.id}/`)}
                >
                  {charge?.relatedEntity?.displayName}
                </div>
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans("description")}:`}
              </td>
              <td className="align-left">
                {charge?.description}
              </td>
            </tr>
          </table>
          <div style={{ position: "relative", top: "0px" }}>
            {!this.props.newCardStyles ?
              <div style={{ display: "flex", alignItems: "center" }}>
                {this.props.showAmountUsed && (
                  <span style={{ marginRight: "6px", whiteSpace: "nowrap" }}>( {this.props.isSettled ? this.formatter.formatNumber(this.props.settlementAmount) : this.formatter.formatNumber(this.props.linkedPayment?.amountDetails[charge?.id])} )</span>
                )}
                <Charge2State
                  {...this.props}
                  charge={charge}
                />
              </div>
              : !charge?.isFullyPaid() && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ fontSize: "16px" }}>
                    {this.trans("payment").toLowerCase()}
                  </div>
                  <div style={{ marginLeft: "5px", fontSize: "16px" }}>
                    {charge?.currency?.getIso()}
                  </div>
                  <div style={{ marginLeft: "5px", fontSize: "16px" }}>
                    {this.formatter.formatNumber(charge?.amount)}
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}
